import styled from 'vue-styled-components';

import theme from '@/config/theme';

const CountLabel = styled.div`
  display: flex;
  gap: ${theme.spacings.xxsmall};
  margin-bottom: 45px;
`;

export const TextP = styled.span`
  text-align: justify;
  overflow: auto;
`;

export default CountLabel;
